export default "__VITE_ASSET__f70159e9__"